/*# sourceMappingURL=tag-labels.component-QYUGFSZ6.css.map */
